import React, { useState } from 'react';
import { db } from '../../Firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { turkishBadWordsFilter } from '../../utils/turkishBadWordsFilter';
import './ContactPage.css';
import TelekomInternet from '../FiberInternet/FiberInternet';

const ContactPage = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        message: ''
    });

    const [inputErrors, setInputErrors] = useState({
        name: '',
        email: '',
        phone: '',
        message: ''
    });

    const [submitting, setSubmitting] = useState(false);

    const validateField = (name, value) => {
        if (name === 'phone') {
            const phoneRegex = /^5[0-9]{2}\s?[0-9]{3}\s?[0-9]{2}\s?[0-9]{2}$/;
            if (!phoneRegex.test(value)) {
                return 'Lütfen geçerli bir telefon numarası giriniz (5XX XXX XX XX)';
            }
        } else if (name === 'email') {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(value)) {
                return 'Lütfen geçerli bir e-posta adresi giriniz';
            }
        } else if (name === 'name' || name === 'message') {
            if (turkishBadWordsFilter.isProfane(value)) {
                return 'Lütfen uygun bir dil kullanınız';
            }
        }
        return '';
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));

        const error = validateField(name, value);
        setInputErrors(prev => ({ ...prev, [name]: error }));
    };

    const validateForm = () => {
        let isValid = true;
        const newErrors = { ...inputErrors };

        Object.keys(formData).forEach(key => {
            if (!formData[key]) {
                newErrors[key] = 'Bu alan zorunludur';
                isValid = false;
            } else {
                const error = validateField(key, formData[key]);
                newErrors[key] = error;
                if (error) isValid = false;
            }
        });

        setInputErrors(newErrors);
        return isValid;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            toast.error('Lütfen formdaki hataları düzeltin');
            return;
        }

        setSubmitting(true);

        try {
            await addDoc(collection(db, 'contacts'), {
                ...formData,
                contactDate: serverTimestamp(),
                isClean: !turkishBadWordsFilter.isProfane(JSON.stringify(formData))
            });

            setFormData({
                name: '',
                email: '',
                phone: '',
                message: ''
            });

            toast.success('Mesajınız başarıyla gönderildi! En kısa sürede sizinle iletişime geçilecektir.');
        } catch (error) {
            console.error('Mesaj gönderilirken hata:', error);
            toast.error('Mesaj gönderilirken bir hata oluştu. Lütfen tekrar deneyin.');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="contact-page">
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />

            {/* Hero Section */}
            <section className="contact-hero">
                <div className="container">
                    <h1>Bize Ulaşın</h1>
                    <p>Profesyonel ekibimiz size en iyi hizmeti sunmak için burada</p>
                </div>
            </section>

            <div className="container main-contact-container">
                <div className="contact-content">
                    <div className="contact-info">
                        <h2>Yardıma mı ihtiyacınız var? Bizimle İletişime Geçin</h2>
                        <p>İhtiyacınız olan internet paketini birlikte seçelim. Şimdi bize ulaşın.</p>

                        <div className="contact-methods">
                            <div className="contact-method">
                                <div className="contact-icon-wrapper">
                                    <img className="contact-icon" src='https://cdn.prod.website-files.com/6851aa1c6adbbffe6510349d/68553de6b5f2bb7969ed708f_e28df69f567118390eb705b9c032b56e_Contact%20One%20Call%20Icon.svg' alt="Telefon" />
                                </div>
                                <div className="contact-details">
                                    <h3>Telefon</h3>
                                    <p>0544-524 00 40</p>
                                    <p>0850 807 98 98</p>
                                    <a href="tel:+905445240040" className="contact-text-btn">Hemen arayın</a>
                                </div>
                            </div>

                            <div className="contact-method">
                                <div className="contact-icon-wrapper">
                                    <img className="contact-icon" src='https://cdn.prod.website-files.com/6851aa1c6adbbffe6510349d/68553de6b5f2bb7969ed708e_b8ee4d00ecf2bcdbf71669c0a83bb602_Contact%20One%20Location%20Icon.svg' alt="Konum" />
                                </div>
                                <div className="contact-details">
                                    <h3>Adres</h3>
                                    <p>Sarıçam/Adana</p>
                                    {/* <a
                                        href="https://maps.app.goo.gl/2z9EoB4i31bA1XVLA"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="contact-text-btn"
                                    >
                                        Konumu görüntüle
                                    </a>

                                    <div className="contact-map">
                                        <iframe
                                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d827.2312271030911!2d35.38334336370864!3d37.05924263546904!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15288d007f2c4a7f%3A0xfdb579bd7db273c1!2zRmF0dXJhbWF0aWsgU2FyxLHDp2FtIELDtmxnZSBCYXlp!5e0!3m2!1str!2str!4v1752411964369!5m2!1str!2str"
                                            allowfullscreen=""
                                            width="100%"
                                            height="400"
                                            style={{ border: 0, borderRadius: '8px' }}
                                            allowFullScreen=""
                                            loading="lazy"
                                            referrerPolicy="no-referrer-when-downgrade"
                                            title="Şirket Konumu"
                                        ></iframe>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* İletişim Formu */}
                    <div className="contact-form-container">
                        <form onSubmit={handleSubmit} className="contact-form">
                            <div className="form-group">
                                <label htmlFor="name">Ad & Soyad</label>
                                <input
                                    type="text"
                                    id="name"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleInputChange}
                                    placeholder="Adınız Soyadınız"
                                    className={inputErrors.name ? 'has-error' : ''}
                                />
                                {inputErrors.name && <span className="error-message">{inputErrors.name}</span>}
                            </div>

                            <div className="form-group">
                                <label htmlFor="email">E-Posta</label>
                                <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleInputChange}
                                    placeholder="E-posta adresiniz"
                                    className={inputErrors.email ? 'has-error' : ''}
                                />
                                {inputErrors.email && <span className="error-message">{inputErrors.email}</span>}
                            </div>

                            <div className="form-group">
                                <label htmlFor="phone">Telefon</label>
                                <input
                                    type="tel"
                                    id="phone"
                                    name="phone"
                                    value={formData.phone}
                                    onChange={handleInputChange}
                                    placeholder="(5XX) XXX XX XX"
                                    className={inputErrors.phone ? 'has-error' : ''}
                                />
                                {inputErrors.phone && <span className="error-message">{inputErrors.phone}</span>}
                            </div>

                            <div className="form-group">
                                <label htmlFor="message">Mesaj</label>
                                <textarea
                                    id="message"
                                    name="message"
                                    value={formData.message}
                                    onChange={handleInputChange}
                                    placeholder="Mesajınız"
                                    className={inputErrors.message ? 'has-error' : ''}
                                ></textarea>
                                {inputErrors.message && <span className="error-message">{inputErrors.message}</span>}
                            </div>

                            <button
                                type="submit"
                                className="submit-btn"
                                disabled={submitting}
                            >
                                {submitting ? 'GÖNDERİLİYOR...' : 'MESAJI GÖNDER'}
                            </button>
                        </form>
                    </div>
                </div>
            </div>
            <TelekomInternet />
        </div>
    );
};

export default ContactPage;